/* funzioni per cambiare i parametri della pagina valor_inmueble*/









$( document ).ready(function() {


  
});